import Marquee from "react-fast-marquee";

const ITEMS = [
  "No obligation to sell",
  "Explore selling options",
  "Local Columbus focus",
  "Any condition considered",
  "No traditional listing",
];

export const EditorialMarquee = () => {
  return (
    <div className="border-y border-ink/10 py-7 bg-cream-deep" data-testid="marquee">
      <Marquee speed={38} gradient gradientColor="#EFE6D6" gradientWidth={100}>
        {ITEMS.concat(ITEMS).map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif italic text-ink/80 text-3xl md:text-4xl px-8">{item}</span>
            <span className="text-gold text-2xl">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
};
